enum FamilyLeaveFund {
  BARSEL_DK = 'DK Barsel.dk',
  DA_BARSEL = 'DK DABarsel',
  BARSEL_DK_PARTIAL = 'DK Partial Barsel.dk',
  OTHER = 'DK Other',
}
export default FamilyLeaveFund
